const BUCKET_NAME = 'state.battery';

export default class ThingBatteryController {
    /** @ngInject */
    constructor(EventEmitter) {
        this.eventEmitter = EventEmitter;
    }

    $onInit() {
        this.aboveValue = '';
        this.belowValue = '';
    }

    $onChanges(changes) {
        if (changes.reset) {
            if (!changes.reset.isFirstChange() && changes.reset.currentValue === true) {
                this.resetValues();
            }
        }
    }

    onChange() {
        const thingBattery = this.getThingBattery();

        if (Object.keys(thingBattery).length) {
            this.fillBucket();

            this.pushUpdate(
                this.eventEmitter({
                    value: thingBattery
                })
            );
        } else {
            this.clearBucket();
        }
    }

    getThingBattery() {
        const thingBattery = {};

        if (this.aboveValue.toString().length) {
            thingBattery.above = this.aboveValue;
        }

        if (this.belowValue.toString().length) {
            thingBattery.below = this.belowValue;
        }

        return thingBattery;
    }

    fillBucket() {
        this.addItemToBucket(
            this.eventEmitter({
                item: {
                    name: BUCKET_NAME,
                    value: this.getThingBattery()
                }
            })
        );
    }

    clearBucket() {
        this.removeItemFromBucket(
            this.eventEmitter({
                item: {
                    name: BUCKET_NAME
                }
            })
        );
    }

    resetValues() {
        this.aboveValue = '';
        this.belowValue = '';

        this.clearBucket();
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-battery/thing-battery.controller.js